import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUserUiStateProject } from '@app/api/interfaces/user-ui-state-project.interface';
import {
  IMainProjectSelectionState,
  mainProjectSelection,
} from '@app/main/main-screen/store/main-selection/main-project-selection/main-project-selection.state';
import { IMapTarget } from '@app/main/main-content/map/interfaces/map-target.interface';

export const selectMainProjectSelectionState = createFeatureSelector<IMainProjectSelectionState>(mainProjectSelection);

export const selectMainProjectState = createSelector(
  selectMainProjectSelectionState,
  (state: IMainProjectSelectionState): IUserUiStateProject => state.uiState
);

export const selectMainProjectSelectionIsInitialized = createSelector(
  selectMainProjectSelectionState,
  (state: IMainProjectSelectionState): boolean => state.initialized
);

export const selectMainProjectSelectionIsLoading = createSelector(
  selectMainProjectSelectionState,
  (state: IMainProjectSelectionState): boolean => state.loading
);

export const selectMainProjectSelectionIsSaving = createSelector(
  selectMainProjectSelectionState,
  (state: IMainProjectSelectionState): boolean => state.saving
);

export const selectMainAreaId = createSelector(
  selectMainProjectSelectionState,
  (state: IMainProjectSelectionState): string | undefined => state.uiState.areaId
);

export const selectMainMapTarget = createSelector(
  selectMainProjectSelectionState,
  (state: IMainProjectSelectionState): IMapTarget | undefined => {
    return state.uiState.mapCenter && state.uiState.mapZoom
      ? {
          center: state.uiState.mapCenter,
          zoom: state.uiState.mapZoom,
        }
      : undefined;
  }
);
